
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.784 32.835"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 291","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"Rectangle 184","d":"M3.267 7.401h19.251v18.407a6.028 6.028 0 01-6.028 6.028h-7.2a6.028 6.028 0 01-6.023-6.028V7.401h0z"}}),_c('path',{attrs:{"data-name":"Path 550","d":"M24.784 5.504a1.9 1.9 0 01-1.9 1.9H2.891a1.9 1.9 0 110-3.791h19.993a1.894 1.894 0 011.9 1.891z"}}),_c('path',{attrs:{"data-name":"Path 551","d":"M17.183 2.895a1.909 1.909 0 01-.137.713h-8.3a1.909 1.909 0 01-.137-.713 1.9 1.9 0 011.9-1.9h4.781a1.9 1.9 0 011.893 1.9z"}}),_c('g',{attrs:{"data-name":"Group 290","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"Line 35","d":"M17.567 11.381v15.271"}}),_c('path',{attrs:{"data-name":"Line 36","d":"M12.893 11.381v15.271"}}),_c('path',{attrs:{"data-name":"Line 37","d":"M8.219 11.381v15.271"}})])])])
          )
        }
      }
    